export enum AlexiApplicationTypes {
  LOAN_APPLICATION = '',
  RECURRING_APPLICATION = 'recurring',
  PARTNER_CONNECT_APPLICATION = 'partnerConnectApplication',
  KYC_ONBOARDING = 'kyc-onboarding',
  SG_VENDORS_ONBOARDING = 'sg-vendors-onboarding',
  AGENT_CLIENT_ONBOARDING = 'agent-client-onboarding',
  AMZ = 'AMZ',
  TTS = 'TTS',
  LAZ = 'LAZ',
  SOP = 'SOP',
  DSME = 'DSME',
  SG_NETS_ONBOARDING = 'sg-kyb-nets',
  NETS = 'NETS',
  SG_NETS_CO_APPLICANT = 'co-applicant-nets-kyc',
}

export enum AlexiApplicationQueryTypes {
  PLD = 'PLD',
  PLC = 'PLC',
  RRF = 'RRF',
  SGV = 'SGV',
  DSME = 'DSME',
}
